import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdvfyz7trd: FaireProductEntity = {
  token: "p_pdvfyz7trd",
  type: "product",
  name: "Zircon Inlaid 18K Gold Plated S.Steel Huggie Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/4e5b064b0d20f713a8be552bb16be3a39bb570e8f23b34650455adbc59aebb01.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9be24f98f11a16afa65c3325b756814621d291e15e5e3c544c4b0bec69ec7004.jpeg",
    "https://cdn.faire.com/fastly/87eab9c24aebff55c6227c4acfe8457b1b7cecf9bc148f4b10355971b7d11b9b.jpeg",
    "https://cdn.faire.com/fastly/d92aedd6bc77992e5e3c68c425896abb539dd7a2a105bcc29c92d94fe010d22b.jpeg",
    "https://cdn.faire.com/fastly/85f1e761387dfa16980bfe23ab0fe8421d090dc677d8c98d3388a0e7464104d7.jpeg",
    "https://cdn.faire.com/fastly/151a107f40c47d97fb8e80f856378c3e289d2de43d2dd8c6c9c9851b74159b00.jpeg",
    "https://cdn.faire.com/fastly/01da75c7858cc6fede9244470aa479cf78eb45540ee58de9a307dffaa4a5fe66.jpeg",
  ],
  priceDollars: 8.27,
  description:
    "Type: Earrings\nMaterial : Stainless steel ，Zircon，18K gold plated\nSize :14mm*27mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 20.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:06.285Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
